import React, { useCallback } from 'react'
import banner from "../../../assets/kangaroo/AustraliaBanner.jpg"
import SectionContainer from '../../../Homepage/SectionContainer'
import './BrandHomepage.css'
import bannerimage from "../../../assets/kangaroo/bannerImg.webp"
import img1 from "../../../assets/kangaroo/1.png"
import img2 from "../../../assets/kangaroo/2.png"
import { div } from 'framer-motion/client'
import { Col, Row } from 'reactstrap'
import { Link2 } from 'lucide-react'
import { Link } from 'react-router-dom'
import main1 from "../../../assets/downloads/Main1.pdf"

const BrandHomepage = () => {
    const text = `<span class="fw-bold fs-5">Welcome to KEFEVS's Brand Identity Guidelines</span>
At Kangaroo Education Foundation Education & Visa Services (KEFEVS), we are dedicated to empowering students on their journey to academic and professional success. With our commitment to excellence, integrity, and personalized support, KEFEVS has become a trusted name in global education consultancy.
This Brand Identity Guidelines document is designed to ensure that every aspect of KEFEVS's communication reflects our core values and resonates with our audience. By maintaining consistency across all touchpoints, we can present a unified, professional, and impactful brand experience.


<span class="fw-bold fs-5">Why This Brand Identity Guidelines?</span>
Our brand is more than a logo or a tagline-it is the essence of who we are and what we represent. These guidelines serve as a roadmap for creating cohesive and compelling materials that align with KEFEVS's mission and vision. From visual elements to tone of voice, this document ensures that KEFEVS communicates with clarity, consistency, and purpose.


<span class="fw-bold fs-5">Structure of the Guidelines</span>
The Brand Identity Guidelines are divided into three key sections:

<span class="fw-bold fs-5">Brand</span>
This section outlines the core elements of KEFEVS’s visual identity, including our logo, color palette, and typography. These components form the foundation of KEFEVS’s recognizable and professional image. Detailed guidance is provided to ensure consistent and effective use of these elements across all platforms.
<span class="fw-bold fs-5">Identity</span>
This section delves into the creative and visual expressions of KEFEVS’s brand. It defines how the structure of every communication and corporate visual form is created, covering various types of materials such as brand communication, sales communication, corporate communication, and other corporate assets.
Each material type is developed to ensure that every aspect of KEFEVS's brand is effectively promoted. This section also includes the essential components that make up these materials, ensuring they align with KEFEVS’s identity and purpose. By adhering to these guidelines, we ensure consistency, coherence, and professionalism across all visual and communication touchpoints.
<span class="fw-bold fs-5">Guidelines</span>
This section provides detailed instructions for the structure and specifications of KEFEVS's materials. It includes required sizes (horizontal and vertical formats), proper content, and the ideal use of visuals and imagery.
By outlining the visual and verbal frameworks for each type of material, this section ensures that all content resonates with KEFEVS's core values and meets the needs of its stakeholders. Following these structured guidelines empowers KEFEVS to deliver strong, impactful, and unified communications across all platforms and channels.`;



    const handleDownload = useCallback((file, name) => {
        const newWindow = window.open("", "_blank");
        if (newWindow) {
            newWindow.document.write(`
                <html>
                    <head>
                        <title>${name ? name : 'Artwork Asset'}</title>
                        <link rel="icon" href="/logo.svg" />
                        <style>
                            body { margin: 0; overflow: hidden; background-color: #121212; display: flex; flex-direction: column; height: 100vh; font-family: sans-serif; }
                            .header { padding: 15px 30px; background: #1e1e1e; display: flex; justify-content: space-between; align-items: center; box-shadow: 0 2px 10px rgba(0,0,0,0.5); z-index: 10; }
                            .title-text { color: #fff; font-size: 16px; font-weight: 500; }
                            .download-btn { background: #812990; color: white; border: none; padding: 10px 24px; border-radius: 6px; cursor: pointer; font-weight: bold; text-decoration: none; font-size: 14px; transition: background 0.2s; }
                            .download-btn:hover { background: #6a1a78; }
                            .content { flex: 1; width: 100%; height: 100%; position: relative; overflow: hidden; display: flex; justify-content: center; align-items: center; padding: 20px; box-sizing: border-box; }
                            .content img { max-width: 100%; max-height: 100%; object-fit: contain; box-shadow: 0 0 20px rgba(0,0,0,0.3); }
                            iframe { width: 100%; height: 100%; border: none; display: block; }
                        </style>
                    </head>
                    <body>
                        <div class="header">
                            <div class="title-text">${name ? name : 'Asset Preview'}</div>
                            <a class="download-btn" href="${file}" download="${name ? name : ''}">Download</a>
                        </div>
                        <div class="content">
                            ${file.match(/\.(jpeg|jpg|gif|png|svg)(\?.*)?$/i)
                    ? `<img src="${file}" alt="Asset Preview" />`
                    : `<iframe src="${file}"></iframe>`
                }
                        </div>
                    </body>
                </html>
            `);
            newWindow.document.close();
        } else {
            // Fallback if popup blocker intervenes
            window.open(file, "_blank");
        }
    }, []);

    return (
        <div>

            <div
                className="hero-banner"
                style={{
                    "--banner-img": `url("${bannerimage}")`,

                }}
            >
                <SectionContainer>
                    {/* <BreadCrumb
                    items={[
                        { title: "HOME", link: "/" },

                        { title: countrydata?.name?.toUpperCase() || "DESTINATION" },
                    ]}
                    country={true}
                    instituition={true}
                /> */}
                    <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">

                    </div>
                </SectionContainer>
            </div>

            <SectionContainer>
                <h1 className='identity-font-level-1' style={{ marginTop: "5rem" }}>BRAND.<span style={{ color: "#D70A84" }}>IDENTITY. <br /></span>GUIDELINES. <span className="country-paragraph-text text-muted">V: 2.0 - December 2024</span></h1>
                <div
                    className="country-paragraph-text"
                    style={{ whiteSpace: "pre-line", marginTop: "5rem" }}
                    dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<span class="text-gap"></span>') }}
                />
                <hr className="line " style={{ marginBottom: "1.25rem", marginTop: "6rem" }} />
                <Row className="d-flex align-items-center hover-item py-2">
                    <Col lg={1} className="d-flex justify-content-center mb-4 mb-sm-0"><img src={img1} className="img-fluid" style={{ width: "50px" }} alt="" /></Col>
                    <Col lg={9}>
                        <Link to="/brand-identity-guideline" className="d-flex text-decoration-none align-items-center">
                            <p className='font-level-5 mb-0 me-3'>ENTER BRAND.IDENTITY.GUIDELINES SITE</p>
                            <Link2 color="#812990" className="hover-item-icon" />
                        </Link>
                    </Col>
                </Row>
                <hr className="line my-3" />
                <Row className="d-flex align-items-center hover-item py-2">
                    <Col lg={1} className="d-flex justify-content-center mb-4 mb-sm-0"><img src={img2} className="img-fluid" style={{ width: "50px" }} alt="" /></Col>
                    <Col lg={9}>
                        <div className="d-flex align-items-center" onClick={() => handleDownload(main1, "Brand-Identity-Guideline.pdf")}>
                            <p className='font-level-5 mb-0 me-3'>DOWNLOAD BRAND IDENTITY GUIDELINES</p>
                            <Link2 color="#812990" className="hover-item-icon" />
                        </div>
                    </Col>
                </Row>
                <hr className="line my-3" />
                <Row className="d-flex align-items-center hover-item py-2">
                    <Col lg={1} className="d-flex justify-content-center mb-4 mb-sm-0"><img src={img2} className="img-fluid mx-auto " style={{ width: "50px" }} alt="" /></Col>
                    <Col lg={9}>
                        <Link to="/artwork" className='text-decoration-none'>
                            <div className="d-flex align-items-center">
                                <p className='font-level-5 mb-0 me-3'>DOWNLOAD ARTWORKS & ASSETS</p>
                                <Link2 color="#812990" className="hover-item-icon" />
                            </div>
                        </Link>
                    </Col>
                </Row>
                <hr className="line mt-3" style={{ marginBottom: "10rem" }} />

            </SectionContainer>

        </div>
    )
}

export default BrandHomepage